import application, { query as queryApplications } from './application';
import helpcontent, { query as queryHelpContent } from './helpfiles';
import idmuserinfo, { query as queryUsers } from './idmuserinfo';
import ProtektorResourceModel from './protektor-resource';
import ProtektorRolesModel from './protektor-roles';
import teams, { query as queryTeams } from './teams';
import PendingResetModel from './pendingresets';
import UserCountModel from './user-count';
import updateCounts from './userCountUtil';
import PingID, { query as queryPingID } from './pingid';
import apnkeycert, { query as queryapnKeyCert } from './apnKeyCert';
import apnauthtoken, { query as queryapnAuthToken } from './apnAuthToken';
import Fgcm, { query as queryfgcm } from './fgcmModel';
import Sso, { query as querySso } from './sso';
import TokenExchange, { query as queryTokenExchange } from './tokenexchange';
import
SelfProvisioningUserInfo,
{ query as querySelfProvisioningUserInfo }
  from './self-provisioning-user-info';

export {
  application as ApplicationModel,
  queryApplications,
  helpcontent as HelpModel,
  queryHelpContent,
  idmuserinfo as IdmuserinfoModel,
  queryUsers,
  ProtektorResourceModel,
  ProtektorRolesModel,
  teams as TeamsModel,
  queryTeams,
  PendingResetModel,
  UserCountModel,
  updateCounts,
  apnkeycert as apnKeyCertModel,
  queryapnKeyCert,
  apnauthtoken as apnAuthTokenModel,
  queryapnAuthToken,
  Fgcm as fgcm,
  queryfgcm,
  PingID as PingIDModel,
  queryPingID,
  Sso as SsoModel,
  querySso,
  TokenExchange as TokenExchangeModel,
  queryTokenExchange,
  SelfProvisioningUserInfo as SelfProvisioningUserInfoModel,
  querySelfProvisioningUserInfo,
};

export default {
  ApplicationModel: application,
  queryApplications,
  HelpModel: helpcontent,
  queryHelpContent,
  IdmuserinfoModel: idmuserinfo,
  queryUsers,
  ProtektorResourceModel,
  ProtektorRolesModel,
  TeamsModel: teams,
  queryTeams,
  PendingResetModel,
  UserCountModel,
  updateCounts,
  apnKeyCertModel: apnkeycert,
  queryapnKeyCert,
  apnAuthTokenModel: apnauthtoken,
  queryapnAuthToken,
  fgcm: Fgcm,
  queryfgcm,
  PingIDModel: PingID,
  queryPingID,
  SsoModel: Sso,
  querySso,
  TokenExchangeModel: TokenExchange,
  queryTokenExchange,
  SelfProvisioningUserInfoModel: SelfProvisioningUserInfo,
  querySelfProvisioningUserInfo,
};
